import { motion } from 'framer-motion';
import { MapPin, Heart, Rocket } from 'lucide-react';

export const About = () => {
  return (
    <section id="about" className="py-24 lg:py-32 bg-slate-50/50 dark:bg-slate-900/50" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left - Visual */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="grid grid-cols-2 gap-4">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="col-span-2 bg-gradient-to-br from-[#25D366] to-emerald-500 rounded-3xl p-8 text-white"
              >
                <MapPin className="w-10 h-10 mb-4 opacity-80" />
                <h3 className="text-2xl font-bold mb-2">Made in India</h3>
                <p className="opacity-90">Built with love in Bangalore, serving professionals across the country.</p>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="bg-white dark:bg-slate-800 rounded-3xl p-6 border border-slate-200 dark:border-slate-700"
              >
                <Heart className="w-8 h-8 text-red-500 mb-3" />
                <p className="text-3xl font-bold text-slate-900 dark:text-white">100%</p>
                <p className="text-slate-500 dark:text-slate-400 text-sm">User Privacy</p>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="bg-white dark:bg-slate-800 rounded-3xl p-6 border border-slate-200 dark:border-slate-700"
              >
                <Rocket className="w-8 h-8 text-blue-500 mb-3" />
                <p className="text-3xl font-bold text-slate-900 dark:text-white">24/7</p>
                <p className="text-slate-500 dark:text-slate-400 text-sm">Always Available</p>
              </motion.div>
            </div>
          </motion.div>

          {/* Right - Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <span className="text-[#25D366] font-semibold text-sm uppercase tracking-wider">About AssistlyAI</span>
            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white leading-tight">
              Built by Indians.
              <br />
              <span className="text-slate-500 dark:text-slate-400">For Indians.</span>
              <br />
              <span className="gradient-text">On the app Indians love.</span>
            </h2>
            <div className="mt-6 space-y-4 text-lg text-slate-600 dark:text-slate-400 leading-relaxed">
              <p>
                We built AssistlyAI because we were tired of juggling 10 different apps just to stay on top of our work. 
                And we knew WhatsApp was the one app every Indian already checks 50 times a day.
              </p>
              <p>
                So we brought the power of a personal assistant right into WhatsApp. No new apps to download. 
                No steep learning curves. Just natural conversations that get things done.
              </p>
              <p>
                Whether you're a startup founder in Bangalore, a CA in Delhi, or a doctor in Mumbai — 
                AssistlyAI speaks your language (literally) and understands how you work.
              </p>
            </div>

            <div className="mt-8 flex flex-wrap gap-4">
              <div className="flex items-center gap-2 text-slate-600 dark:text-slate-400">
                <span className="w-2 h-2 bg-[#25D366] rounded-full" />
                <span>Proudly bootstrapped</span>
              </div>
              <div className="flex items-center gap-2 text-slate-600 dark:text-slate-400">
                <span className="w-2 h-2 bg-[#25D366] rounded-full" />
                <span>No VC pressure</span>
              </div>
              <div className="flex items-center gap-2 text-slate-600 dark:text-slate-400">
                <span className="w-2 h-2 bg-[#25D366] rounded-full" />
                <span>User-first always</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
